import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import Button from 'components/Button'
import { RemoveItemModalFooter, RemoveItemModalText } from '../ecosystemData/style'

const RemoveCriterionCModal = ({ closeModal, confirmRemove, item }) => {
  return (
    <>
      <RemoveItemModalText data-testid='modal-body'>
        Are you sure you want to permanently remove <b>{item?.EcoRegion?.name || ''}</b> from the list? This action cannot be
        undone.
      </RemoveItemModalText>
      <RemoveItemModalFooter>
        <Button type='secondary' onClick={closeModal}>
          <FormattedMessage id='cancel' />
        </Button>
        <Button type='destructive' onClick={confirmRemove}>
          <FormattedMessage id='yesRemove' />
        </Button>
      </RemoveItemModalFooter>
    </>
  )
}

RemoveCriterionCModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  confirmRemove: PropTypes.func.isRequired,
  item: PropTypes.shape({
    EcoRegion: PropTypes.shape({
      name: PropTypes.string
    })
  })
}

export default RemoveCriterionCModal
